import React, { useState } from 'react';

const st = {
  wrap: { display: 'flex', flexWrap: 'wrap', gap: 6, padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 8, minHeight: 44, cursor: 'text' },
  tag:  { background: '#eff6ff', color: '#1d4ed8', fontSize: 13, padding: '3px 10px', borderRadius: 20, display: 'flex', alignItems: 'center', gap: 6 },
  remove: { background: 'none', border: 'none', cursor: 'pointer', color: '#93c5fd', fontWeight: 700, fontSize: 15, padding: 0 },
  input:  { border: 'none', outline: 'none', fontSize: 14, flex: 1, minWidth: 120, color: '#1e293b' },
};

export default function TagInput({ value, onChange, placeholder }) {
  const [inputVal, setInputVal] = useState('');

  function addTag(tag) {
    const trimmed = tag.trim();
    if (trimmed && !value.includes(trimmed)) onChange([...value, trimmed]);
    setInputVal('');
  }

  function handleKeyDown(e) {
    if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); addTag(inputVal); }
    else if (e.key === 'Backspace' && !inputVal && value.length > 0) onChange(value.slice(0, -1));
  }

  return (
    <div style={st.wrap} onClick={(e) => e.currentTarget.querySelector('input').focus()}>
      {value.map((tag) => (
        <span key={tag} style={st.tag}>
          {tag}
          <button style={st.remove} onClick={() => onChange(value.filter((t) => t !== tag))}>×</button>
        </span>
      ))}
      <input
        style={st.input}
        value={inputVal}
        onChange={(e) => setInputVal(e.target.value)}
        onKeyDown={handleKeyDown}
        onBlur={() => inputVal && addTag(inputVal)}
        placeholder={value.length === 0 ? placeholder : ''}
      />
    </div>
  );
}
